<div class="ccl-alert ccl-alert--{{ variant }}" role="alertdialog">
  <div class="ccl-alert__content">
    @if (showIcon) {
      <span class="ccl-alert__icon">
        {{ icon || getDefaultIcon() }}
      </span>
    }
    
    <div class="ccl-alert__text">
      @if (title) {
        <h4 class="ccl-alert__title">{{ title }}</h4>
      }
      <span class="ccl-alert__message">{{ message }}</span>
    </div>
  </div>

  @if (dismissible) {
    <button
      class="ccl-alert__close"
      type="button"
      aria-label="Close"
      (click)="close()"
    >
      ✕
    </button>
  }
</div>
  